module.exports = __webpack_public_path__ + "img/logo_off.740bbf1d.svg";